import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import SEO from '../components/SEO'
import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './sub-page.css'

const SERVICE_GALLERY_DATA = {
  '/arac-koruma': {
    badge: 'ARAÇ KORUMA FAALİYET ALANI',
    title: 'Araç Koruma & Hazırlık Süreçleri',
    mainImg: 'https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Conrad Beşiktaş stüdyosunda lüks araç yüzey hazırlığı ve koruma uygulaması',
    mainCaption: 'Kapalı stüdyo ortamında araç yüzey analizi ve boya koruma hazırlık aşaması.',
    subImg: 'https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Araç koruma sonrası yüzey derinliği ve kristal parlaklık',
    subCaption: 'Boya mühürleme ve koruma katmanı sonrası ayna berraklığında yüzey finisajı.',
  },
  '/arac-kaplama': {
    badge: 'ARAÇ KAPLAMA FAALİYET ALANI',
    title: 'Dökme Cast Folyo Renk Değişimi & Uygulama Detayları',
    mainImg: 'https://images.pexels.com/photos/10162529/pexels-photo-10162529.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Özel renk tonunda dökme cast folyo araç kaplama çalışması',
    mainCaption: 'Panel birleşimleri ve gövde hatlarına kusursuz oturan dökme vinil folyo uygulaması.',
    subImg: 'https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Araç kaplama sonrası panel bitişleri ve estetik renk dönüşümü',
    subCaption: 'Orijinal boyaya zarar vermeyen, geri döndürülebilir premium renk değişimi.',
  },
  '/boya-koruma': {
    badge: 'BOYA KORUMA FAALİYET ALANI',
    title: 'Vernik Mühürleme & Koruma Katmanı',
    mainImg: 'https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Vernik yüzeyine polimer boya koruyucu mühürleme uygulaması',
    mainCaption: 'Güneşin UV ışınlarına ve asit yağmurlarına karşı vernik gözeneklerinin mühürlenmesi.',
    subImg: 'https://images.pexels.com/photos/30837753/pexels-photo-30837753.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Boya koruma sonrası derin parlaklık ve kaygan yüzey',
    subCaption: 'Hidrofobik su iticilik ve uzun ömürlü parlak koruma kalkanı.',
  },
  '/seramik-kaplama': {
    badge: 'SERAMİK KAPLAMA FAALİYET ALANI',
    title: 'Nano Seramik Katman & Ayna Parlaklığı',
    mainImg: 'https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Seramik kaplama sonrası cam pürüzsüzlüğünde derin ayna yansıması',
    mainCaption: 'Vernikle kovalent bağ kuran nano seramik ile derin ayna parlaklığı ve çizilme direnci.',
    subImg: 'https://images.pexels.com/photos/30837753/pexels-photo-30837753.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Seramik koruma sonrası mikron düzeyinde pürüzsüz boya finisajı',
    subCaption: 'Yüksek su ve kir iticilik ile kolay temizlenme ve kalıcı parlaklık.',
  },
  '/detayli-arac-temizligi': {
    badge: 'İÇ DETAILING FAALİYET ALANI',
    title: 'Kabin İçi Derinlemesine Arındırma & Deri Kondisyonlama',
    mainImg: 'https://images.pexels.com/photos/6873188/pexels-photo-6873188.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'İç mekan deri döşeme ve konsol detaylı arındırma uygulaması',
    mainCaption: 'Hassas fırçalar ve pH nötr köpüklerle deri ve döşemelerin fabrikasyon matlığına kavuşturulması.',
    subImg: 'https://images.pexels.com/photos/20042054/pexels-photo-20042054.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Deri koltuk kondisyonlama ve detaylı temizlik finisajı',
    subCaption: 'Deri çatlamalarını önleyen UV koruyucu besleyici bakım ve hijyen sterilizasyonu.',
  },
  '/boya-duzeltme': {
    badge: 'BOYA DÜZELTME FAALİYET ALANI',
    title: 'Işık Altı Çizik & Hare Arındırma İşlemleri',
    mainImg: 'https://images.pexels.com/photos/11139244/pexels-photo-11139244.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Özel stüdyo ışıkları altında vernik çizik ve hare giderme aşaması',
    mainCaption: 'Vernik mikron kalınlığı korunarak hare, hologram ve kılcal çiziklerin giderilmesi.',
    subImg: 'https://images.pexels.com/photos/30837753/pexels-photo-30837753.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Boya düzeltme sonrası sıfır hare ayna berraklığı',
    subCaption: 'Optik berraklık kazandırılmış, showroom kondisyonunda pürüzsüz boya yüzeyi.',
  },
  '/polisaj': {
    badge: 'POLİSAJ FAALİYET ALANI',
    title: 'Aşamalı Pasta Cila & Finisaj Uygulaması',
    mainImg: 'https://images.pexels.com/photos/11139244/pexels-photo-11139244.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Dual-action ve rotary polisaj makineleriyle pasta cila uygulaması',
    mainCaption: 'Rotary ve dual-action makinelerle vernik yüzeyine zarar vermeden uygulanan profesyonel finisaj.',
    subImg: 'https://images.pexels.com/photos/14231701/pexels-photo-14231701.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Pasta cila sonrası pürüzsüz yüzey yansıması',
    subCaption: 'Boya derinliğini ve renk doygunluğunu en üst seviyeye çıkaran pasta cila aşaması.',
  },
  '/far-parlatma': {
    badge: 'FAR PARLATMA FAALİYET ALANI',
    title: 'Polikarbonat Far Restorasyonu & Berraklık',
    mainImg: 'https://images.pexels.com/photos/30837753/pexels-photo-30837753.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Sararmış far camlarının aşamalı sulu zımpara ve polimer buharıyla yenilenmesi',
    mainCaption: 'Oksitlenmiş ve sararmış katmanın mikron seviyesinde temizlenip optik berraklığa kavuşturulması.',
    subImg: 'https://images.pexels.com/photos/36021355/pexels-photo-36021355.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Far parlatma sonrası kristal netliğinde ışık geçirgenliği ve koruma',
    subCaption: 'Gece aydınlatma performansını ilk günkü fabrika seviyesine taşıyan UV korumalı mühürleme.',
  },
  '/cam-filmi': {
    badge: 'CAM FİLMİ FAALİYET ALANI',
    title: 'Isı Kontrollü & UV Korumalı Cam Filmi Uygulaması',
    mainImg: 'https://images.pexels.com/photos/10162529/pexels-photo-10162529.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Oto cam filmi montajı ve ısı tabancasıyla şekillendirme aşaması',
    mainCaption: 'Gövde camlarına sıfır toz toleransıyla uygulanan yüksek ısı ve UV blokajlı cam filmi.',
    subImg: 'https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Cam filmi sonrası estetik görünüm ve kabin gizliliği',
    subCaption: 'Sürüş konforunu artıran, iç mekanı güneş yıpranmalarına karşı koruyan garantili cam filmi.',
  },
  '/buharli-arac-temizligi': {
    badge: 'BUHARLI HİJYEN FAALİYET ALANI',
    title: 'Kuru Buhar Teknolojisi & Antibakteriyel Dezenfeksiyon',
    mainImg: 'https://images.pexels.com/photos/20042054/pexels-photo-20042054.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Yüksek sıcaklıkta kuru buharla araç içi antibakteriyel arındırma',
    mainCaption: 'Havalandırma kanalları ve koltuk dokularında kimyasal kalıntı bırakmadan %99.9 bakteri sterilizasyonu.',
    subImg: 'https://images.pexels.com/photos/6873188/pexels-photo-6873188.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Buharlı temizlik sonrası ferah ve steril araç kabini',
    subCaption: 'Kötü kokuları kaynağında yok eden, alerjenlerden arındırılmış sağlıklı kabin ortamı.',
  },
  '/detayli-motor-temizligi': {
    badge: 'MOTOR DETAILING FAALİYET ALANI',
    title: 'Kaput Altı Yağ Arındırma & Antistatik Koruma',
    mainImg: 'https://images.pexels.com/photos/15085608/pexels-photo-15085608.jpeg?auto=compress&cs=tinysrgb&w=1500',
    mainAlt: 'Kaput altı motor bölmesi detaylı temizlik ve koruma çalışması',
    mainCaption: 'Elektronik aksamlara zarar vermeden uygulanan hassas arındırma ve antistatik koruma işlemi.',
    subImg: 'https://images.pexels.com/photos/6969026/pexels-photo-6969026.jpeg?auto=compress&cs=tinysrgb&w=1500',
    subAlt: 'Detaylı motor temizliği sonrası sıfır kondisyon görünümü',
    subCaption: 'Plastik ve kauçuk hortumları çatlamaya karşı koruyan ısıya dayanıklı mat kaplama.',
  },
}

const SubPage = ({
  title,
  seoTitle,
  category,
  description,
  canonicalPath,
  noindex = false,
  features,
  galleryData,
}) => {
  const defaultFeatures = [
    {
      title: 'Uzman İşçilik & Deneyim',
      text: 'Her araç özel ilgi ve yüksek hassasiyetle stüdyomuzda kusursuz şekilde işlenir.',
    },
    {
      title: 'Premium Malzeme Standardı',
      text: 'Sektörün en prestijli, sertifikalı ve uzun ömürlü koruma ürünleri kullanılmaktadır.',
    },
    {
      title: 'Garantili Uygulama',
      text: 'Tüm uygulamalarımız müşteri memnuniyeti ve kalite garantisi altındadır.',
    },
  ]

  const activeFeatures = features || defaultFeatures
  const gallery = galleryData || SERVICE_GALLERY_DATA[canonicalPath]

  return (
    <div className="subpage-container teleport-dashboard-layout">
      {/* Merkezi Teknik SEO Meta Yönetimi */}
      <SEO
        title={seoTitle || `${title} | ATEŞ AUTO DETAILING`}
        description={
          description ||
          `${title} uygulaması, süreç detayları ve fiyat teklifi için ATEŞ Auto Detailing Beşiktaş stüdyomuzla iletişime geçin.`
        }
        canonicalPath={canonicalPath}
        noindex={noindex}
      />

      <aside className="subpage-sidebar-wrapper teleport-dashboard-sidebar">
        <Navigation></Navigation>
      </aside>

      <main id="tq-main" className="subpage-content-wrapper teleport-dashboard-content">
        {/* Hero Bölümü */}
        <section className="subpage-hero">
          <nav aria-label="Breadcrumb" className="subpage-breadcrumb">
            <Link to="/">ANA SAYFA</Link>
            <span className="subpage-breadcrumb-separator">/</span>
            <span>{category || 'HİZMETLERİMİZ'}</span>
            <span className="subpage-breadcrumb-separator">/</span>
            <span aria-current="page">{title}</span>
          </nav>

          <h1 className="subpage-headline">{title}</h1>

          <p className="subpage-description">
            {description ||
              `${title} hizmetimiz hakkında kapsamlı bilgi almak ve stüdyomuzdan randevu oluşturmak için bizimle iletişime geçin.`}
          </p>

          <div className="subpage-actions">
            <a href="tel:+905346442153" className="subpage-btn-primary">
              TEKLİF AL / RANDEVU
            </a>
            <a
              href="https://wa.me/905346442153"
              target="_blank"
              rel="noreferrer noopener"
              className="subpage-btn-secondary"
            >
              WHATSAPP BİLGİ
            </a>
          </div>
        </section>

        {/* Gövde ve Faaliyet Alanı Görselleri */}
        <section className="subpage-body">
          {/* Faaliyet Alanı Görsel Vitrini */}
          {gallery && (
            <div className="subpage-showcase-section">
              <div className="subpage-showcase-header">
                <span className="subpage-showcase-badge">{gallery.badge}</span>
                <h2 className="subpage-showcase-title">{gallery.title}</h2>
              </div>
              <div className="subpage-showcase-grid">
                <div className="subpage-showcase-card">
                  <div className="subpage-showcase-img-wrap">
                    <img
                      src={gallery.mainImg}
                      alt={gallery.mainAlt}
                      loading="lazy"
                      decoding="async"
                      className="subpage-showcase-img"
                    />
                    <span className="subpage-img-tag">UYGULAMA AŞAMASI</span>
                  </div>
                  <p className="subpage-showcase-caption">{gallery.mainCaption}</p>
                </div>

                <div className="subpage-showcase-card">
                  <div className="subpage-showcase-img-wrap">
                    <img
                      src={gallery.subImg}
                      alt={gallery.subAlt}
                      loading="lazy"
                      decoding="async"
                      className="subpage-showcase-img"
                    />
                    <span className="subpage-img-tag">YÜZEY FİNİSAJI</span>
                  </div>
                  <p className="subpage-showcase-caption">{gallery.subCaption}</p>
                </div>
              </div>
            </div>
          )}

          {/* Özellik Kartları */}
          <div className="subpage-cards-grid">
            {activeFeatures.map((f, i) => (
              <div key={i} className="subpage-card">
                <div className="subpage-card-icon">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
                <h3 className="subpage-card-title">{f.title}</h3>
                <p className="subpage-card-text">{f.text}</p>
              </div>
            ))}
          </div>

          <div className="subpage-notice-box">
            <span className="subpage-notice-title">ÖZEL STÜDYO RANDEVUSU</span>
            <p className="subpage-notice-text">
              Conrad Istanbul Bosphorus Otoparkı içerisindeki stüdyomuzda randevu sistemiyle hizmet vermekteyiz.
              Aracınıza en uygun paket ve uygulama için uzmanlarımızla görüşebilirsiniz.
            </p>
          </div>
        </section>

        <Footer></Footer>
      </main>
    </div>
  )
}

SubPage.propTypes = {
  title: PropTypes.string.isRequired,
  seoTitle: PropTypes.string,
  category: PropTypes.string,
  description: PropTypes.string,
  canonicalPath: PropTypes.string.isRequired,
  noindex: PropTypes.bool,
  features: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
    })
  ),
  galleryData: PropTypes.shape({
    badge: PropTypes.string,
    title: PropTypes.string,
    mainImg: PropTypes.string,
    mainAlt: PropTypes.string,
    mainCaption: PropTypes.string,
    subImg: PropTypes.string,
    subAlt: PropTypes.string,
    subCaption: PropTypes.string,
  }),
}

export default SubPage
